/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 *
 * This Application Error function handles common and uncommon errors, most often through a generic message.
 * To use it for a custom message to the user you need to pass 3 props
 * error:             PropTypes.string:   "Custom"
 * fromErrorBoundary: PropTypes.Bool:     true
 * customMessage:     PropTypes.string:   The message you want to send the user
 */

import Bugsnag from '@bugsnag/js';
import Types from '../constants/actionTypes';
import { getCurrentUser } from '../utils/reduxHelpers';

export function applicationError(error, fromErrorBoundary, customMessage) {
  return (dispatch) => {
    const user = getCurrentUser();
    if ((!user || !user.id) && !fromErrorBoundary) return;
    dispatch({ type: Types.CLEAR_ACTIVE_SPINNER });
    if (error === 401) return;

    Bugsnag.notify(error);

    const { message, stack } = error;
    // console.log('MESSAGE IS =>', message);
    // console.log('error => ', error);

    console.error(stack);

    if (message === undefined && error === 'Custom') {
      // Enable Passing a Custom Message that coaches the user through the error
      dispatch({ type: Types.APPLICATION_ERROR, message: customMessage });
    } else if (
      message === 'Failed to fetch' /* chrome */ ||
      message === 'Load failed' /* safari */
    ) {
      const serverDownMessage =
        'Cannot connect to the Agile Dezign server - please refresh your browser and let us know if the issue persists.';
      dispatch({ type: Types.SERVER_ERROR, message: serverDownMessage });
    } else if (message === 'Unauthorized') {
      dispatch({ type: Types.CLOSE_ALL_MODALS });
      dispatch({ type: Types.USER_LOGOUT });
    } else {
      console.log('error => ', error);
      const genericMessage = `Hmmm... something seems to have gone wrong. We're looking into it!`;
      dispatch({ type: Types.APPLICATION_ERROR, message: genericMessage });
      // setTimeout(() => dispatch({ type: Types.HIDE_NOTIFICATION }), 5000);
    }
    return null;
  };
}

export function hideNotification() {
  return (dispatch) => {
    dispatch({ type: Types.HIDE_NOTIFICATION });
  };
}

export function notificationAction(message, autoDismiss = -1) {
  return (dispatch) => {
    dispatch({ type: Types.SUCCESS_ACTION, message });
    if (autoDismiss > -1)
      setTimeout(
        () => dispatch({ type: Types.HIDE_NOTIFICATION }),
        autoDismiss * 1000
      );
  };
}

export function startDrag() {
  return (dispatch) => {
    dispatch({ type: Types.DRAG_STATUS, status: true });
  };
}

export function endDrag() {
  return (dispatch) => {
    dispatch({ type: Types.DRAG_STATUS, status: false });
  };
}

export function setHoverBackground(hoverBackground) {
  return (dispatch) => {
    dispatch({ type: Types.SET_HOVER_BACKGROUND, hoverBackground });
  };
}
